import EsusView from 'components/esus/EsusView'

export default function FichaAtendimentoIndividualView() {
  return <EsusView url='/pec/user/cds/atendimentoIndividual' />
}
